import { useFeature } from '@optimizely/react-sdk';

export const GetShowCtaMessage = (allocationsAvailable) => {
  const [isAvailableRoomsEnabled, variables] = useFeature('qantas-hotels-available-rooms-message');
  const availableRoomsMaxCutoff = variables?.['max-rooms-cutoff'] ?? 5;
  const showCtaMessage =
    isAvailableRoomsEnabled && allocationsAvailable && allocationsAvailable > 0 && allocationsAvailable <= availableRoomsMaxCutoff;
  return !!showCtaMessage;
};
